module.exports = __webpack_public_path__ + "fonts/TradeGothicLTStd.fbb1aa8.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TradeGothicLTStd.otf
// module id = ./src/assets/fonts/TradeGothicLTStd.otf
// module chunks = 34